import styled from 'styled-components';
import { CollapsibleContentArrow } from 'ui/collapsibleContent';
import { Body1Bold, Body2, colors, smallShadow, spacing } from 'ui/theme';

export const CardWrapper = styled.div`
  background-color: ${colors.white};
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};
  ${smallShadow}

  & + & {
    margin-top: ${spacing.plusHalf};
  }
`;

export const CardRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const Details = styled.button`
  flex-grow: 1;
  display: grid;
  grid-template-areas:
    'indicator logo title'
    'indicator logo metadata';
  grid-template-columns: auto auto 1fr;
  align-items: center;
  column-gap: ${spacing.base};
  padding: ${spacing.base} ${spacing.base} ${spacing.base} ${spacing.plusHalf};
  border: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;

export const StyledCollapsibleContentArrow = styled(CollapsibleContentArrow)`
  grid-area: indicator;
`;

export const Logo = styled.div`
  grid-area: logo;
  width: ${spacing.x3};
  height: ${spacing.x3};
`;

export const Title = styled(Body1Bold)`
  grid-area: title;
  margin-bottom: 0;
  text-align: initial;
`;

export const Metadata = styled(Body2)`
  grid-area: metadata;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  color: ${colors.textSecondary};
`;

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};

  & + & {
    &:before {
      content: '';
      width: ${spacing.quarter};
      height: ${spacing.quarter};
      margin-left: ${spacing.half};
      margin-right: ${spacing.quarter};
      background-color: ${colors.iconSubtle};
      border-radius: 50%;
    }
  }
`;

export const CardActions = styled.div`
  grid-area: actions;
  display: flex;
  gap: ${spacing.half};
  padding: ${spacing.base} ${spacing.plusHalf} ${spacing.base} ${spacing.base};
`;
